import {
  Component,
  Injector,
  OnInit
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forEach as _forEach, map as _map } from 'lodash-es';
import { AppComponentBase } from '@shared/app-component-base';
import {
  ProfissionalSaudeDto,
  AssinaturaServiceProxy,
  AssinaturaDto
} from '@shared/service-proxies/service-proxies';
import { StringUtils } from '@shared/helpers/StringUtils';

@Component({
  templateUrl: './view-situacao-pagamento-dialog.component.html'
})
export class ViewSituacaoPagamentoDialogComponent extends AppComponentBase implements OnInit {

  userId: number;
  assinatura: AssinaturaDto;

  constructor(
    injector: Injector,
    private _assinaturaService: AssinaturaServiceProxy,
    public bsModalRef: BsModalRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (!this.assinatura) {
      abp.ui.setBusy();
      this._assinaturaService.obterAssinatura(this.userId)
        .pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        )
        .subscribe(x => {
          this.assinatura = x;
          this.assinatura.status = StringUtils.getSituacao(this.assinatura.status);
        });
    } else {
      this.assinatura.status = StringUtils.getSituacao(this.assinatura.status);
    }
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
